import { Zap, Layers, TrendingUp } from "lucide-react";

const ITEMS = [
  {
    icon: Zap,
    tag: "Friction",
    title: "Ops eat your team.",
    copy: "Tabs, tools, follow-ups, spreadsheets. Every hire adds coordination cost — not output.",
    accent: "#EF4444",
  },
  {
    icon: Layers,
    tag: "Automation",
    title: "One connected stack.",
    copy: "Chat, voice, CRM, content, ads, HR — a single AI graph that shares context in real time.",
    accent: "#8B5CF6",
  },
  {
    icon: TrendingUp,
    tag: "Impact",
    title: "Ship 10× cheaper.",
    copy: "Founders report ~40% lower ops cost and ~3× faster response times within 6 weeks.",
    accent: "#22C55E",
  },
];

export default function Positioning() {
  return (
    <section id="product" className="py-20 sm:py-28 relative" data-testid="positioning-section">
      <div className="max-w-[1240px] mx-auto px-5 sm:px-8">
        <div className="max-w-[720px] mb-12 sm:mb-16">
          <span className="yg-eyebrow" data-testid="positioning-eyebrow">// The shift</span>
          <h2 className="yg-h2 text-[clamp(30px,4.6vw,52px)] mt-3 text-white">
            From <span className="text-[var(--yg-red)]">friction</span> to{" "}
            <span className="text-[var(--yg-violet-light)]">automation</span> to{" "}
            <span className="text-[var(--yg-green)]">impact</span>.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-4 sm:gap-5">
          {ITEMS.map((it, i) => {
            const Icon = it.icon;
            return (
              <div
                key={it.tag}
                className="yg-card yg-card-hover p-6 sm:p-7 min-h-[240px] flex flex-col justify-between"
                data-testid={`positioning-card-${it.tag.toLowerCase()}`}
                style={{ animation: `yg-rise 700ms ${i * 100}ms both cubic-bezier(.2,.9,.3,1)` }}
              >
                <div>
                  <div
                    className="w-10 h-10 rounded-[10px] flex items-center justify-center mb-5"
                    style={{ background: `${it.accent}18`, border: `1px solid ${it.accent}44` }}
                  >
                    <Icon className="w-5 h-5" style={{ color: it.accent }} />
                  </div>
                  <div className="yg-mono text-[10px] tracking-[0.24em] uppercase mb-2" style={{ color: it.accent }}>
                    {it.tag}
                  </div>
                  <h3 className="text-white font-extrabold text-[22px] sm:text-[24px] tracking-[-0.02em] leading-[1.05]">
                    {it.title}
                  </h3>
                </div>
                <p className="text-[14px] leading-relaxed text-[var(--yg-text-mute)] mt-6">{it.copy}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
